import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <p>If we translate Lewin’s ideas for use in the working environment,
                                                the state of equilibrium could
                                                represent an employee’s present level of productivity, in terms
                                                of working towards task completion.
                                                If we want to maintain this level of productivity we have to
                                                maintain equilibrium; that is, ensure
                                                that the individual experiences a balanced state of being.</p>
                                            <p>In thinking about maintaining momentum, it’s also worthwhile
                                                considering the concept of ‘flow’.<a className="superscripttext"
                                                                                     href="further_info.php?course=300"><sup>5</sup></a>
                                                Flow is a mental state in which a person is fully immersed in
                                                what he or she is doing. It is
                                                characterised by a feeling of energised focus, complete
                                                involvement in the task at hand and
                                                success in the process of the activity. In other words, flow
                                                appears to be a state of being where
                                                a person is optimally engaged in an activity and constantly
                                                moving towards a successful outcome.
                                                Considering flow from this angle indicates its potential value
                                                for maintaining energy and,
                                                therefore, momentum, over a period of time.</p>
                                            <p>Interestingly, people who have described their ‘flow experiences’
                                                in research studies used the
                                                metaphor of a ‘current carrying them along’ to describe it. Once
                                                again the idea of movement and
                                                momentum is reinforced.</p>
                                            <p>You might say: ‘so what?’</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading paratop">
                                                <p>From the above, we can deduce that in order to maintain
                                                    momentum for the purpose of
                                                    task completion, one should aim to achieve a state of
                                                    flow.</p>

                                            </div>
                                            <p>...and then ask: ‘how does one obtain a state of flow?’</p>
                                            <p>In order to arrive at an answer, it’s important to note that flow
                                                is an ideal state and that its
                                                attainment is not guaranteed for every task. The good news,
                                                however, is that there are certain
                                                factors or conditions that contribute to the experience of flow
                                                – and better still, not all of these
                                                factors are needed for flow to be experienced!</p>
                                            <div className="uiheading"><p><span className="subtiltereg">The implications are that:</span>
                                            </p></div>
                                            <ul className="greenbullet-list">
                                                <li>We can manipulate situations and tasks so that the
                                                    probability of experiencing flow is
                                                    enhanced.
                                                </li>
                                                <li>Individuals can discover which factors make them work more
                                                    effectively (i.e. move them
                                                    towards the flow experience) and introduce these factors to
                                                    their working lives.
                                                </li>

                                            </ul>
                                            <p>We can roughly link some of the factors that contribute to the
                                                flow experience to the driving and/
                                                or restraining forces (also see the Energy field model on the
                                                next page) albeit not perfectly.</p>
                                            <div className="mobile-scroll">
                                                <table className="ilead_v_sport tablesrink paraspace paratop"
                                                       border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve " align="left" valign="top"
                                                            width="35%">FLOW FACTORS
                                                        </th>
                                                        <th align="left" valign="top" width="20%">Matched to:
                                                            DRIVING FORCES
                                                        </th>
                                                        <th className=" green_curve1" align="left" valign="top"
                                                            width="25%">Matched to: RESTRAINING FORCES
                                                        </th>

                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="35%"><p>Clear goals</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>Goal-setting (according
                                                            to SMART formula)
                                                        </p></td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="25%">
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="35%"><p>Concentration and focus</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%">
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="25%"><p>(Opposite of) boredom</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="35%"><p>Loss of the feeling of
                                                            self-consciousness</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>Positive emotional state</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="25%">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="35%"><p>Direct and immediate feedback</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>Constructive feedback</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="25%">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="35%"><p>Balance between ability level
                                                            and challenge
                                                        </p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>Motivation</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="25%">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="35%"><p>Sense of personal control</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>Coping skill</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="25%"><p>Workplace/personal
                                                            stressors
                                                        </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="35%"><p>Activity is intrinsically
                                                            rewarding</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>Motivation
                                                        </p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="25%">
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="35%"><p>Absorption in and complete focus on
                                                            the activity, with distorted sense of time</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>Positive cognition/
                                                            positive emotional state</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="25%">
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}